/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum GameModeTag {
  default = 'default',
  openQuickGame = 'openQuickGame',
  practice = 'practice',
  practiceTournament = 'practiceTournament',
  threeCard = 'threeCard',
  tournament = 'tournament'
}

/**
 * GameModeTag
 *
 * The specific tag of different game modes
 */
export const GameModeTagEnumType = types.enumeration('GameModeTag', [
  'default',
  'openQuickGame',
  'practice',
  'practiceTournament',
  'threeCard',
  'tournament'
])
